import validate from "/fire-bang-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import add_45promocode_45global from "/fire-bang-frontend/src/middleware/add-promocode.global.ts";
export const globalMiddleware = [
  validate,
  add_45promocode_45global
]
export const namedMiddleware = {}